import AI_ASSISTANT_SETTINGS_CONFIG from '../../../configs/aiAssistantSettings.config';

/**
 * Pairs half-width settings into rows; an `isFullRow` setting gets a row of its own: [a, b, c, full] →
 * [[a, b], [c], [full]]. Done in JS, not CSS wrapping, because a lone tile lays out differently from a paired one.
 */

const isFullRowSetting = (settingName) => !!AI_ASSISTANT_SETTINGS_CONFIG[settingName].isFullRow;

const canPair = (row, settingName) => {
    if (row?.length !== 1) return false;

    if (isFullRowSetting(row[0])) return false;

    return !isFullRowSetting(settingName);
};

export const groupSettingsIntoRows = (settingNames) => {
    const rows = [];

    settingNames.forEach((settingName) => {
        const lastRow = rows[rows.length - 1];

        if (canPair(lastRow, settingName)) lastRow.push(settingName);
        else rows.push([settingName]);
    });

    return rows;
};
